import React from 'react';

const WelcomeMessage = ({ themes, chatType }) => {
    return (
        <div className="mt-3 place-self-start text-left">
            <div
                className="mt-3 p-3 rounded-2xl"
                style={{
                    backgroundColor: "white",
                    color: themes.secondryFontColor,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                }}
            >
                <div className="break-words text-md">
                    <p>Chào mừng bạn đến với {chatType === 'spa' ? 'Chanh Spa Nail' : chatType === 'tantien' ? 'Tân Tiến' : chatType === 'smtminhha' ? 'SMT Minh Hà' : 'Sudo Ecommerce'}!</p>
                    <p>Hãy nhập câu hỏi của bạn để được hỗ trợ.</p>
                </div>
            </div>
        </div>
    );
};

export default WelcomeMessage;
